function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, InputNumber, Alert, Tag, Upload } from 'antd';
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import { Row, Col, Container } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SetUrine = function SetUrine(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler,
    _ref$update = _ref.update,
    update = _ref$update === void 0 ? false : _ref$update;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    Object.entries(values).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      formData.append(key, value === undefined || value === '' || value === "null" || value === null ? '' : value);
    });
    axios.post(Common.baseApiUrl + "seturine", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (update == true) {
      form.setFieldsValue({
        sang: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.sang : "",
        sucre: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.sucre : "",
        albumine: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.albumine : "",
        cetonique: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.cetonique : "",
        bilirubine: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.bilirubine : "",
        urobilinogene: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.urobilinogene : "",
        nitrites: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.nitrites : "",
        leucocytes: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.leucocytes : "",
        densite: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.densite : "",
        ph: candidat.laboratory_result.urine != null ? candidat.laboratory_result.urine.ph : ""
      });
    }
    form.setFieldsValue({
      comment: ""
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Sang",
            name: "sang",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Glucose",
            name: "sucre",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Prot\xE9ine",
            name: "albumine",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Corp c\xE9tonique",
            name: "cetonique",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Bilirubine",
            name: "bilirubine",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Urobilinog\xE8ne",
            name: "urobilinogene",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Nitrites",
            name: "nitrites",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Leucocytes",
            name: "leucocytes",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Densit\xE9",
            name: "densite",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "PH",
            name: "ph",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 2
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })
  });
};
export default SetUrine;